/**
 * Created by sam on 06.03.2017.
 */

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace FormSubtype {
  export const FORM_COPYNUMBER_SUBTYPE_ID = 'copynumber_subtype';
  export const FORM_EXPRESSION_SUBTYPE_ID = 'expression_subtype';
}
